<style lang="scss" scoped>
@import "../../styles/mixins";
@import "../../styles/variables";

.deviceTest {
  height: 100%;
  background-color: #f4f4f4;
}
.inner {
  width: 1200px;
  margin: 0 auto;
}
.info {
  height: 90px;
  // width: 1200px;
  margin: 20px auto;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
  line-height: 90px;
  color: #ff8a00;
  font-size: 24px;
  background-color: #fff;
  position: relative;
}
.steps {
  display: grid;
  height: 600px;
  grid-template-columns: 300px 1fr;
  grid-column-gap: 30px;
  // box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
  .tab {
    background-color: #fff;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    display: grid;
    grid-template-rows: repeat(4, auto);
    &:hover {
      cursor: pointer;
    }
    .active {
      background-color: $navBarColor;
      color: white;
      position: relative;
      &::after {
        content: "";
        // background-color: #264f78;
        // background-color: red;
        position: absolute;
        left: 300px;
        top: 50%;
        transform: translateY(-50%);
        // width: 30px;
        // height: 30px;
        // border-color: red;
        // border-top: 30px solid red;
        // border: 30px solid red;
        // border-top: none;
        // border-left: none;
        @include css-arrow("right", $navBarColor, 10px);
        // border-right: none;
        // border-right: none;
        // border-bottom: none;
      }
      .subtitle {
        color: white !important;
      }
    }
    > div {
      border-bottom: 1px solid #d9ecff;
    }
    > div:last-child {
      border: none;
    }
    .tabItem {
      > p > img {
        transform: translateX(-5px) translateY(4px);
      }
      .subtitle {
        font-size: 12px;
        color: #aaa;
      }
    }
  }
  .content {
    background-color: #fff;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    .goWrapper {
      .el-button {
        border: none;
        width: 100px;
        height: 40px;
        background-color: #ffc831;
        color: #b16614;
        border-radius: 20px;
      }
    }
  }
}
::v-deep .el-loading-mask {
  .el-loading-spinner {
    top: 80%;
    i {
      color: #b16614;
    }
  }
}
.goBack{
  position: absolute;
  right: 20px;
  top: 20px;
}
</style>
<template>
  <div class="deviceTest">
    <div class="inner">
      <div class="info">
        <img style="transform: translateY(4px)" src="../../assets/images/notice.png" alt> 为了保证考试顺利完成，请按步骤完成设备检测，才能进行考试。
        <el-button class="goBack" @click="handleGoBack">返回</el-button>
      </div>
      <div class="steps">
        <div class="tab">
          <div :class="{active: activeIndex === 1, tabItem: true}" @click="handleClickTab(1)">
            <p v-show="activeIndex === 1">
              <img src="../../assets/images/mic.png" alt>第一步
            </p>
            <p v-show="activeIndex !== 1">
              <img src="../../assets/images/mic-b.png" alt>第一步
            </p>
            <p class="subtitle">麦克风检测</p>
          </div>
          <div :class="{active: activeIndex === 2, tabItem: true}" @click="handleClickTab(2)">
            <p v-show="activeIndex === 2">
              <img src="../../assets/images/camera.png" alt>第二步
            </p>
            <p v-show="activeIndex !== 2">
              <img src="../../assets/images/camera-b.png" alt>第二步
            </p>
            <p class="subtitle">摄像头检测</p>
          </div>
          <!-- <div :class="{active: activeIndex === 3, tabItem: true}" @click="handleClickTab(3)">
            <p v-show="activeIndex === 3">
              <img src="../../assets/images/browser.png" alt>第三步
            </p>
            <p v-show="activeIndex !== 3">
              <img src="../../assets/images/browser-b.png" alt>第三步
            </p>
            <p class="subtitle">浏览器测试</p>
          </div> -->
          <div :class="{active: activeIndex === 3, tabItem: true}" @click="handleClickTab(4)">
            <p v-show="activeIndex === 3">
              <img src="../../assets/images/test.png" alt>第三步
            </p>
            <p v-show="activeIndex !== 3">
              <img src="../../assets/images/test-b.png" alt>第三步
            </p>
            <p class="subtitle">考前测试</p>
          </div>
          <div :class="{active: activeIndex === 4, tabItem: true}" @click="handleClickTab(5)">
            <p v-show="activeIndex === 4">
              <img src="../../assets/images/checkdone.png" alt>第四步
            </p>
            <p v-show="activeIndex !== 4">
              <img src="../../assets/images/checkdone-b.png" alt>第四步
            </p>
            <p class="subtitle">完成</p>
          </div>
        </div>
        <div class="content">
          <keep-alive>
            <!-- <router-view></router-view> -->
            <component
              @audioCheckStart="deviceStatus.is_microphone = 0"
              @videoCheckStart="deviceStatus.is_camera=0"
              @audioReady="deviceStatus.is_microphone=1"
              @videoReady="deviceStatus.is_camera=1"
              @browserReady="deviceStatus.is_chrome=1"
              @practiceDone="deviceStatus.is_mc_ide=deviceStatus.is_scratch_ide=deviceStatus.is_python_ide=deviceStatus.is_c_ide=1"
              v-bind:is="currentTabComponent"
              :deviceStatus="deviceStatus"
              :checkPassed="checkPassed"
              :is_online="myExam.is_online"
            ></component>
          </keep-alive>
          <p class="goWrapper">
            <el-button v-show="activeIndex > 1" class="goPrev" @click="handleGoPrev" :disabled="this.myExam.is_online === 1 && activeIndex < 4">上一步</el-button>
            <el-button
              :disabled="loading"
              v-show="activeIndex < 4"
              class="goNext"
              @click="handleGoNext"
            >下一步</el-button>
            <el-button v-show="activeIndex === 4" class="goNext" @click="handleFinish">完成</el-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StepOne from './steps/StepOne.vue';
import StepTwo from './steps/StepTwo.vue';
import StepThree from './steps/StepThree.vue';
import StepFour from './steps/StepFour.vue';
import StepFive from './steps/StepFive.vue';
import {
  postDeviceCheck,
  putDeviceCheck,
  // getServerTime,
  getMyExam,
} from '@/services/getData';
import {
 mapMutations, mapState, mapGetters, mapActions,
} from 'vuex';
import {
 AUTHORITY, EXAMINEE, MYEXAM, SERVERTIME,
} from '@/store/types';

export default {
  data() {
    return {
      // activeIndex: 1,
      activeIndex: parseInt(this.$route.params.step, 10),
      deviceStatus: {
        is_camera: 0,
        is_chrome: 1,
        is_microphone: 0,
        is_mc_ide: 0,
        is_scratch_ide: 0,
        is_python_ide: 0,
        is_c_ide: 0,
      },
      faceCheck: {},
      asistArr: ['is_microphone', 'is_camera', 'is_chrome', 'is_ide'],
      // serverTime: null,
      // serverTimer: null,
      // isReady: false, // 需要判断是否完成了人脸验证
    };
  },
  methods: {
    ...mapMutations({
      setAuthority: AUTHORITY,
      setExaminee: EXAMINEE,
      setMyExam: MYEXAM,
    }),
    ...mapActions({
      disMyExam: MYEXAM,
    }),
    handleClickTab(index) {},
    handleGoNext() {
      const newIndex = this.activeIndex + 1;
      this.$router.push(`/user/devicetest/${newIndex}`);
    },
    handleGoPrev() {
      const newIndex = this.activeIndex - 1;
      this.$router.push(`/user/devicetest/${newIndex}`);
    },
    // setServerTime() {
    //   getServerTime()
    //     .then((resp) => {
    //       this.serverTime = new Date(resp);
    //       this.serverTimer = setInterval(() => {
    //         // 根据服务器时间设置定时器
    //         this.serverTime = new Date(this.serverTime.valueOf() + 1000);
    //       }, 1000);
    //     })
    //     .catch((err) => {});
    // },
    handleFinish() {
      // return console.log(this.checkPassed, this.deviceStatus);
      const obj = Object.assign(
        {
          examination_examinee_id: this.myExam.id,
        },
        this.deviceStatus,
      );
      if (this.myExam.testing_status !== 1) {
        postDeviceCheck(obj)
          .then((resp) => {
            this.disMyExam(this.authority.admissionTicket).then(() => {
            if (this.checkPassed || this.myExam.is_online === 1) {
              this.$message.success('设备检测成功');
              if (this.canEnterExam && (this.checkedInOneHour || this.uploadedInOneHour || this.myExam.match_category === 3 || this.myExam.match_category === 2 || this.myExam.is_online === 1)) {
                  this.$router.push('/exam');
              } else {
                  // location.href = '/user/myexam';
                  this.$router.push('/user/myexam');
              }
            } else {
              this.$message.error('设备检测未通过');
              this.$router.push('/user/myexam');
            }
            }).catch((err) => {
              console.log(err);
            });
          })
          .catch((err) => {
            if (err && err.status === 422) {
                this.$message.error(err.data.message);
              } else {
                this.$message.error(typeof err === 'string' ? err : '设备检测失败');
              }
          });
      } else if (this.canEnterExam && (this.checkedInOneHour || this.uploadedInOneHour || this.myExam.match_category === 3 || this.myExam.match_category === 2)) {//this.myExam.match_category !== 3
        this.$router.push('/exam');
      } else {
        // location.href = '/user/myexam';
          this.$router.push('/user/myexam');
      }
    },
    onMessageHandler(e) {
      if (e.origin === location.origin) {
        console.log(e, 'devicetest message');
        switch (e.data.event) {
          case 'MOCK_DONE':
              this.onMockDone(e.data);
              this.$alert('恭喜您完成了所有的考前测试项目，点击确定进入下一步', '完成测试', {
                confirmButtonText: '确定',
                callback: (action) => {
                  this.$router.push('/user/devicetest/4');
                },
              });
            break;
          default:
            break;
        }
      }
    },
    onMockDone(data) {
      this.deviceStatus.is_c_ide = this.deviceStatus.is_python_ide = this.deviceStatus.is_mc_ide = this.deviceStatus.is_scratch_ide = 1;
    },
    handleGoBack() {
      this.disMyExam(this.authority.admissionTicket);
      this.$router.push('/user/myexam');
    },
    validateStatus() { // 检查是否已经通过了前面的测试
      const checkList = this.asistArr.slice(0, this.activeIndex - 1);
      if (this.activeIndex === 1) return true;
      return checkList.every((step, index) => this.deviceStatus[step] === 1);
    },
  },
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
  },
  created() {
    // this.setServerTime();
    // this.getMyExam();
    const faceCheck = localStorage.getItem(
      `faceCheck-${this.authority.admissionTicket}`,
    ) || '{}';
    this.faceCheck = JSON.parse(faceCheck);
  },
  mounted() {
    window.addEventListener('message', this.onMessageHandler);
    if (this.myExam.is_online === 0) {
      if (!this.validateStatus()) { // 如果前面有没通过的，就要跳回步骤1
        // this.$router.push('/user/devicetest/1');
        const { href } = this.$router.resolve('/user/devicetest/1');
        location.href = href;
      }
    }

  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessageHandler);
  },
  props: {},
  watch: {
    $route(value) {
      this.activeIndex = parseInt(value.params.step, 10);
    },
  },
  computed: {
    isReady() {
      return this.myExam && this.myExam.examinee_tencent_face_testing || this.faceCheckGetter && this.faceCheckGetter.preuploaded || this.checkedInOneHour || this.uploadedInOneHour;
    },
    currentTabComponent() {
      switch (this.activeIndex) {
        case 1:
          return StepOne;
        case 2:
          return StepTwo;
        // case 3:
        //   return StepThree;
        case 3:
          return StepFour;
        case 4:
          return StepFive;
        default:
          return null;
      }
    },
    loading() {
      console.log(this.deviceStatus);
      console.log(!this.isReady,!this.myExam.is_test_check,(this.myExam.match_category !== 3 || this.myExam.match_category !== 2))
      if (this.isReady && this.myExam.is_test_check) return true;
      switch (this.activeIndex) {
        case 1:
          return !this.deviceStatus.is_microphone;
        case 2:
          return !this.deviceStatus.is_camera;
        // case 3:
        //   return !this.deviceStatus.is_chrome;
        case 3:
          return !(this.deviceStatus.is_scratch_ide && this.deviceStatus.is_mc_ide && this.deviceStatus.is_python_ide && this.deviceStatus.is_c_ide);
        default:
          return false;
      }
    },
    ...mapState({
      authority: 'authority',
      examinee: 'examinee',
      currentUser: 'currentUser',
      myExam: 'myExam',
      serverTime: 'serverTime',
    }),
    ...mapGetters({
      faceCheckGetter: 'faceCheckGetter',
    }),
    canEnterExam() {
      // 除了考前测试，其他状态都可进入考场
      if (
        new Date(this.serverTime) > new Date(this.myExam.end_at)
        || new Date(this.serverTime) < new Date(this.myExam.start_at)
      ) {
        return false;
      }
      return true;
    },
    checkedInOneHour() {
      return this.faceCheck.successStamp && new Date(this.myExam.start_at) - new Date(this.faceCheck.successStamp) < 60 * 60 * 1000;
    },
    uploadedInOneHour() {
     return this.faceCheck.uploadStamp && new Date(this.myExam.start_at) - new Date(this.faceCheck.uploadStamp) < 60 * 60 * 1000;
    },
    checkPassed() {
      return this.deviceStatus && Object.entries(this.deviceStatus).every(
        item => item[1] === 1,
      );
    },
  },
};
</script>
